module.exports = __webpack_public_path__ + "img/ecc916b8-d20b-4702-ba24-116ec2ee87fa.18b7feb1.png";